import PropTypes from 'prop-types';
var ListingModel = {
  url: PropTypes.string.isRequired,
  image: PropTypes.shape({
    highRes: PropTypes.string.isRequired,
    lowRes: PropTypes.string
  }).isRequired,
  address: PropTypes.shape({
    street: PropTypes.string.isRequired,
    suburb: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    postcode: PropTypes.string.isRequired
  }).isRequired,
  agent: PropTypes.shape({
    agencyLogo: PropTypes.string,
    agentPhoto: PropTypes.string,
    agentName: PropTypes.string
  }).isRequired,
  newDevelopment: PropTypes.bool,
  propertyName: PropTypes.string,
  formattedPrice: PropTypes.string.isRequired,
  formattedBeds: PropTypes.string,
  formattedBaths: PropTypes.string,
  formattedParking: PropTypes.string
};
export default ListingModel;